import { useEffect, useState, Fragment } from 'react'

//components
import Subtitle from '../assets/elements/section-subtitle'
import ActionButton from '../assets/elements/button/action-button'
import DeleteButton from '../assets/elements/button/delete-button'
import NotLoggedMessage from '../assets/elements/not_logged_message'
import Loading from '../assets/controls/loading'

//utils
import { postPropertyToCart, deleteBasketProperty } from '../../utils/property-details'
import { isLoggedIn } from '../../utils/user'

//style
import './styles/price.css'
import { SHOW_RATES } from '../../constant/settings'

const Price = ({ floors, data, isViewOnly }) => {
    const [loading, setLoading] = useState(false)
    const [localData, setLocalData] = useState([])
    const [isWarningVisible, setIsWarningVisible] = useState(false)
    const [resetWarningVisible, setResetWarningVisible] = useState(false)

    useEffect(() => {
        setLocalData(data)
    }, [data])

    const addToCart = async (floorId, propertyId) => {
        if (isLoggedIn()) {
            setLoading(true)
            let response = await postPropertyToCart(floorId, propertyId);
            if (response) {
                let formattedData = localData?.map(item => {
                    if (item.floorPlanTypeId === floorId) {
                        return {
                            ...item,
                            addedToCart: true
                        }
                    }
                    else {
                        return item
                    }
                })
                setLocalData(formattedData)
            }
            setLoading(false)
            // await checkIfInCart(propertyId) 
        }
        else {
            setResetWarningVisible(!resetWarningVisible)
            setIsWarningVisible(true)
        }
    };
    const removeFromCart = async (floorId, propertyId) => {
        setLoading(true)
        let response = await deleteBasketProperty(floorId, propertyId);
        if (response) {
            let formattedData = localData?.map(item => {
                if (item.floorPlanTypeId === floorId) {
                    return {
                        ...item,
                        addedToCart: false
                    }
                }
                else {
                    return item
                }
            })
            setLocalData(formattedData)
        }
        setLoading(false)
    }
    return (
        <div>
            <Subtitle>Price</Subtitle>
            <div className='price__wrapper'>
                {localData?.map((floor, index) => (
                    <Fragment key={floor.floorPlanTypeId ?? index}>
                        <div className='price__row'>
                            <div>{floor.name}</div>
                            {SHOW_RATES && <div className='price__row__budget'>{floor.rateInUsd && typeof floor.rateInUsd === 'number' ? <>starting at <span>${floor.rateInUsd} /</span> per night</> : <span>On Request</span>}</div>}
                            <div className='price__row__button'>
                                {!loading ?
                                    isViewOnly ?
                                        <>
                                            <div className='price__button-fullsize'>
                                                <ActionButton action={_ => false}>Contact us to get a Quote</ActionButton>
                                            </div>
                                        </>
                                        :
                                    (!floor.addedToCart ?
                                        <>
                                            <div className='price__button-fullsize'>
                                                <ActionButton action={_ => addToCart(floor.floorPlanTypeId, floor.propertyId)}>Add to Cart for Quotes</ActionButton>
                                            </div>
                                            <div className='price__button-smallsize'>
                                                <ActionButton action={_ => addToCart(floor.floorPlanTypeId, floor.propertyId)}>+ Add</ActionButton>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className='price__button-fullsize'>
                                                <DeleteButton action={_ => removeFromCart(floor.floorPlanTypeId, floor.propertyId)}>Remove from cart</DeleteButton>
                                            </div>
                                            <div className='price__button-smallsize'>
                                                <DeleteButton action={_ => removeFromCart(floor.floorPlanTypeId, floor.propertyId)}>Remove</DeleteButton>
                                            </div>
                                        </>
                                    )
                                    :
                                    <Loading isVisble={loading} size={20} />
                                }
                            </div>
                        </div>
                        {index !== floors.length - 1 && <hr key={`division${index}`} />}
                    </Fragment>

                ))}
            </div>
            <NotLoggedMessage
                message='to add property to the cart'
                visible={isWarningVisible}
                setVisible={setIsWarningVisible}
                resetTrigger={resetWarningVisible}
            />
        </div>
    )
}

export default Price